import { render, staticRenderFns } from "./UserInterface.vue?vue&type=template&id=5b6952b3&scoped=true&"
import script from "./UserInterface.vue?vue&type=script&lang=js&"
export * from "./UserInterface.vue?vue&type=script&lang=js&"
import style0 from "./UserInterface.vue?vue&type=style&index=0&id=5b6952b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6952b3",
  null
  
)

export default component.exports